import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useInit } from "../hooks/useInit";
import { useInputV4 } from "../../stateManagement/useInputV4";

import InputV4 from "../inputs/input_V4";
import Button from "../UI_elements/button";

import { VALIDATOR_EMAIL, VALIDATOR_MINLENGTH, VALIDATOR_MATCH } from "./validators/validators";

const ResetPasswordForm = () => {
  const { token } = useParams();
  const { initState, initStarted, initCompleted, initErrors, initReset } = useInit();
  const { inputState, inputHandler, attachmentHandler, mustMatchHandler } = useInputV4({});
  const [requestSubmitted, setRequestSubmitted] = useState();

  const submitHandler = async (event) => {
    event.preventDefault();
    initStarted(0);
    try {
      const responseData = await axios.put(
        process.env.REACT_APP_BACKEND_URL + `/api/auth/resetpassword/${token}`,
        {
          email: inputState.inputs.email.value,
          password1: inputState.inputs.password1.value,
          password2: inputState.inputs.password2.value,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      setRequestSubmitted(true);
      initCompleted(0);
    } catch (err) {
      console.log(err);
      initErrors(err.response.data.message, 0);
      return;
    }
  };

  return (
    <>
      {requestSubmitted && <div className=" text-center my-4">Your password has been reset. Return to login. </div>}
      {!requestSubmitted && (
        <form className="mt-8" action="#" method="POST" onSubmit={submitHandler}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="-space-y-px rounded-md shadow-sm">
            <div>
              <InputV4
                inputVer="1"
                sid="inputs"
                type="email"
                id="email"
                placeholder={"Email"}
                customClasses={" rounded-md "}
                onInput={inputHandler}
                validators={[VALIDATOR_EMAIL()]}
                validityMessage={"Must be an email"}
              />
            </div>
            <div>
              <InputV4
                inputVer="1"
                sid="inputs"
                type="password"
                id="password1"
                placeholder={"Password"}
                customClasses={" rounded-md "}
                onInput={inputHandler}
                validators={[VALIDATOR_MINLENGTH(6)]}
                validityMessage={"Must be at least 6 charactors"}
              />
            </div>
            <div>
              <InputV4
                inputVer="1"
                sid="inputs"
                type="password"
                id="password2"
                placeholder={"Re-type Password"}
                customClasses={" rounded-md "}
                onInput={inputHandler}
                validators={[VALIDATOR_MATCH(inputState.inputs && inputState.inputs.password1.value)]}
                validityMessage={"Passwords must match"}
              />
            </div>
          </div>

          <div>
            <Button
              type="submit"
              label={"Reset Password"}
              customClasses={`${inputState.isValid ? "bg-taskinatorBlue" : "bg-taskinatorMedGrey"} bg-taskinatorBlue text-taskinatorWhite h-10 w-full mt-2 `}
              disabled={!inputState.isValid}
              isLoading={initState[0].started}
              error={initState[0].error}
            />
          </div>
        </form>
      )}
    </>
  );
};

export default ResetPasswordForm;
